import { Flex, type FlexProps } from '@mantine/core';
import type { ReactElement } from 'react';

/**
 * A space-between row that stacks to a full-width column below the `sm`
 * breakpoint — the canonical "content-left / actions-right that stacks on
 * mobile" layout. Use instead of hand-rolling
 * `Flex direction={{ base: 'column', sm: 'row' }}`. Any Flex prop
 * (gap, align, justify, mt, w, wrap, …) can be overridden.
 */
export default function ResponsiveRow({ children, ...props }: FlexProps): ReactElement {
    return (
        <Flex direction={{ base: 'column', sm: 'row' }} justify="space-between" align={{ base: 'stretch', sm: 'center' }} gap="sm" {...props}>
            {children}
        </Flex>
    );
}
